import View from '@components/navTab/view.vue'
// 根据注册时间切换新旧素材空间
// 启用新素材空间的固定阈值时间：2026-03-01 00:00:00（本地时区）
import trade from "./trade";
import hyc from "./hyc";

const Layout = () => import(/* webpackChunkName: "distributor" */ `@distributor/Layout.vue`)
const Index = () => import(/* webpackChunkName: "distributor" */ `@distributor/home/index.vue`)
const SupplierMine = () => import(/* webpackChunkName: "distributor" */ `@distributor/supplier/mine/index.vue`)
const DistributionSetting = () => import(/* webpackChunkName: "distributor" */ `@distributor/supplier/distributionSetting/index.vue`)
const BillCenter = () => import(/* webpackChunkName: "distributor" */ `@distributor/supplier/billCenter/index.vue`)
const UserManage = () => import(/* webpackChunkName: "distributor" */ `@distributor/base/UserManage.vue`)
const ContactManage = () => import(/* webpackChunkName: "distributor" */ `@distributor/base/ContactManage.vue`)
const ShopManage = () => import(/* webpackChunkName: "distributor" */ `@distributor/base/ShopManage.vue`)
const PlatformConf = () => import(/* webpackChunkName: "distributor" */ `@distributor/prod/conf/index.vue`)
const ProdCenter = () => import(/* webpackChunkName: "distributor" */ `@distributor/prod/center/index.vue`)
const ProductCorrespondence = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/correspondence/index.vue`)
const ProductCorrespondenceConf = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/correspondenceConf/index.vue`)

const ProdRelationship = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/relationship/index.vue`)
const PictureZone = () => import(/* webpackChunkName: "supplier" */`@distributor/prod/picTureZone/index.vue`)
const NewPictureZone = () => import(/* webpackChunkName: "supplier" */`@distributor/prod/newPicTureZone/index.vue`)
const ProdLog  = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/log/index.vue`)
const AutoDistributionRule  = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/autoDistributionRule/index.vue`)
const GoodsFissionRule  = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/goodsFissionRule/index.vue`)
const AIImageUpdate  = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/AIImageUpdate/index.vue`)
const SupplierInfo  = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/supplierInfo/index.vue`)
const MyBusinessCard  = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/myBusinessCard/index.vue`)
const ProductDetail = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/productDetail/index.vue`)
const ShoppingCart = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/shoppingCart/index.vue`)
const OrderConfirm = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/orderConfirm/index.vue`)
const AddressBook = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/addressBook/index.vue`)
const TaskCenter = () => import(/* webpackChunkName: "distributor" */`@/pages/taskCenter/index.vue`)

import DownloadCenter from '../../pages/distributor/trade/downloadCenter/index.vue';
import ErpTaskCenterPage from '@/pages/common/ErpTaskCenter.vue';

const name = (routerName) => `d_${routerName}`;

// 使用 companyCreated（毫秒时间戳）判定是否启用新素材空间
// 路由层按需解析组件，避免在此文件引入 store 造成循环依赖
const resolvePictureZoneComponent = () => {
  // let companyCreated = 0;
  // try {
  //   const raw = window.localStorage.getItem('userinfo');
  //   if (raw) {
  //     const u = JSON.parse(raw);
  //     companyCreated = Number(u && u.companyCreated) || 0;
  //   }
  // } catch (e) {}
  // const START_TS = new Date(2026, 2, 1, 0, 0, 0).getTime(); // 2026-03-01 00:00:00
  // return companyCreated >= START_TS ? NewPictureZone() : PictureZone();
  return NewPictureZone();
}

const routes = [
  {
    path: '/distributor',
    component: Layout,
    redirect: '/distributor/index',
    name: 'distributor',
    children: [
      {
        name: name('index'),
        path: 'index',
        component: Index,
        meta: {
          title: '首页',
          icon: 'el-icon-shouye1'
        }
      },
      {
        path: 'prod',
        name: name('DistributorProd'),
        component: View,
        meta: {
          title: '商品管理',
          icon: 'el-icon-shangpinguanli'
        },
        children: [
          {
            path: 'center',
            name: name("prod_center"),
            component: ProdCenter,
            meta: {
              title: '商品中心'
            }
          },
          {
            path: '/distributor/prod_conf',
            name: name('DistributorProdConf'),
            component: PlatformConf,
            meta: {
              title: '商品平台配置'
            }
          },
          {
            path: 'correspondence',
            name: name('prod_correspondence'),
            // component: ProductCorrespondence,
            meta: {
              title: '商品对应表',
              // erpHash: '#/prod/prod_correspondence_next/',
            }
          },
          {
            path: 'correspondenceConf',
            name: name('prod_correspondence_conf'),
            component: ProductCorrespondenceConf,
            meta: {
              title: '商品对应表配置',
              withoutLeftNav: true,
              showWithPath: '/distributor/prod/correspondence',
              needLogQuery: true,
            }
          },

          {
            path:'/distributor/prod_relationship',
            name: name('Relationship'),
            component: ProdRelationship,
            meta: {
              title: '供分销商品关系'
            }
          },
          {
            path: 'log',
            name: name("prod_log"),
            component: ProdLog,
            meta: {
              title: '商品日志',
              needLogQuery: false,
            }
          },
          {
            path: 'picture_zone',
            name: name("prod_picture_zone"),
            component: resolvePictureZoneComponent,
            meta: {
              title: '商品素材空间'
            }
          },
          {
            path: 'auto_distribution_rule',
            name: name("prod_auto_distribution_rule"),
            component: AutoDistributionRule,
            meta: {
              title: '自动铺货规则'
            }
          },
          {
            path: 'goods_fission_rule',
            name: name("prod_goods_fission_rule"),
            component: GoodsFissionRule,
            meta: {
              title: 'AI爆款裂变'
            }
          },{
            path:'ai_image_updaete',
            name: name("prod_ai_image_updaete"),
            component: AIImageUpdate,
            meta: {
              title: 'AI改图'
            }
          },
          {
            path: 'taskCenter',
            name: name("task_center"),
            component: TaskCenter,
            meta: {
              title: '任务中心'
            }
          },
        ]
      },
      {
        name: name('SupplierManagement'),
        path: 'supplier',
        component: View,
        redirect: 'supplier/mine',
        meta: {
          title: '供销商',
          icon: 'el-icon-gongyingshangguanli'
        },
        children: [
          {
            name: name('SupplierMine'),
            path: 'mine',
            component: SupplierMine,
            meta: {
              title: '供销商管理',
            }
          },
          {
            name: name('DistributionSetting'),
            path: 'setting',
            // component: DistributionSetting,
            meta: {
              title: '分销基础设置',
              needLogQuery: true,
            }
          },
          {
            name: name('BillCenter'),
            path: 'bill',
            component: BillCenter,
            meta: {
              title: '对账中心',
              // showWithPath: '/distributor/supplier/mine',
              // withoutLeftNav: true,
              needLogQuery: true,
            }
          },
          {
            name: name('SupplierMineInfo'),
            path: 'info',
            component: SupplierInfo,
            meta: {
              title: '分销小店',
              showWithPath: '/distributor/supplier/mine',
              withoutLeftNav: true,
              needLogQuery: true,
            }
          },
          {
            name: name('ProductDetail'),
            path: 'productDetail/:productId',
            component: ProductDetail,
            meta: {
              title: '商品详情',
              showWithPath: '/distributor/supplier/mine',
              withoutLeftNav: true,
              needLogQuery: true,
            }
          },{
            name: name('ShoppingCart'),
            path: 'ShoppingCart',
            component: ShoppingCart,
            meta: {
              title: '采购车',
              showWithPath: '/distributor/supplier/mine',
              withoutLeftNav: true,
              needLogQuery: true,
            }
          },{
            name: name('OrderConfirm'),
            path: 'OrderConfirm',
            component: OrderConfirm,
            meta: {
              title: '确认订单',
              showWithPath: '/distributor/supplier/mine',
              withoutLeftNav: true,
              needLogQuery: true,
            }
          }
        ]
      },
      {
        name: name('cooperation'),
        path: '/distributor/cooperate',
        component: View,
        redirect: '/cooperation/invite',
        meta: {
          title: '寻合作',
          icon: 'el-icon-gongyingshangguanli',
          badge: 'New'
        },
        children: [
          {
            name: name('MyBusinessCard'),
            path: 'card',
            component: MyBusinessCard,
            meta: {
              title: '我的分销名片',
              needLogQuery: true,
            }
          },
          {
            path: 'findGoods',
            name: name('FindGoods'),
            meta: {
              title: '找好货',
              badge: '有上新',
              url: '/api/accountGyl/exemptionKmErpAndKmt',
              pageCode: 'GOOD_ITEM',
              external: true
            }
          },
          {
            path: 'findSuppliers',
            name: name('FindSuppliers'),
            meta: {
              title: '找供应商',
              badge: 'New',
              url: '/api/accountGyl/exemptionKmErpAndKmt',
              pageCode: 'FIND_SUPPLIER',
              external: true
            }
          },
          {
            path: 'ksc',
            name: name('KuaiShengCang'),
            meta: {
              title: '快省仓',
              badge: 'New',
              url: '/api/accountGyl/exemptionKmErpAndKmt',
              pageCode: 'FAST_WAREHOUSE',
              external: true,
              bypassFilter: true
            }
          },
        ]
      },
      {
        path: '/distributor/base',
        name: name('DistributorBase'),
        redirect: '/distributor/base/shop',
        component: View,
        meta: {
          title: '基础管理',
          icon: 'el-icon-menu'
        },
        children: [
          {
            name: name('DistributorUser'),
            path: 'user',
            component: UserManage,
            meta: {
              title: '用户管理'
            }
          },
          {
            name: name('DistributorContact'),
            path: 'contact',
            component: ContactManage,
            meta: {
              title: '负责人信息管理'
            }
          },{
            name: name('DistributorAddress'),
            path: 'address',
            component: AddressBook,
            meta: {
              title: '地址管理'
            }
          }
        ]

      },
      {
        name: name('DistributorShop'),
        path: '/distributor/shopManage',
        // component: ShopManage,
        meta: {
          title: '店铺管理',
          icon: 'el-icon-dianpuzhanghaoguanli'
        }
      },
      trade,
      {
        name: name('DistributorOnlineFundManage'),
        path: 'onlineFundManage',
        meta: {
          title: '在线资金管理',
          icon: 'el-icon-shouhou'
        }
      },
      {
        path: 'download_center',
        name: name('DownloadCenter'),
        component: DownloadCenter,
        meta: {
          title: '下载中心',
          icon: 'el-icon-download'
        },
        hide: true,
      },
      // erp下载中心
      {
        path: 'erp_download_center',
        name: name('erpDownloadCenter'),
        meta: {
          title: '下载中心',
          icon: 'el-icon-download'
        },
        hide: true,
      },
      // erp 任务中心
      {
        path: 'erp_task_center',
        name: name('erpTaskCenter'),
        component: () => import('@/pages/common/ErpTaskCenter.vue'),
        meta: {
          title: '任务中心',
        },
        hide: true,
      }
    ]
  },
  hyc
]

// 开发环境将测试模块加进去
if (process.env.NODE_ENV === 'development') {
  routes[0].children.push({
    name: name('test'),
    path: 'test',
    component: View,
    meta: {
      title: '测试模块',
      icon: 'el-icon-menu'
    },
    children: [{
      name: name('t1'),
      path: 't1',
      component: () => import(/* webpackChunkName: "distributor" */ `@distributor/test/test1/index.vue`),
      meta: {
        title: 't1'
      }
    }, {
      name: name('t2'),
      path: 't2',
      component: () => import(/* webpackChunkName: "distributor" */ `@distributor/test/test2/index.vue`),
      meta: {
        title: 't2'
      }
    }]
  })
}

function completionPath(item, parentItem) {
  if (parentItem && item.path && item.path[0] !== '/') {
    item.path = parentItem.path + '/' + item.path
  }

  if (item.children && item.children.length > 0) {
    item.children.forEach(i => {
      completionPath(i, item)
    })
  }
}

routes.forEach(item => {
  completionPath(item)
})
console.log('routes2', routes)

export default routes
